import { render } from "./ReportLotArrivals.vue?vue&type=template&id=81803fc2&scoped=true"
import script from "./ReportLotArrivals.vue?vue&type=script&lang=js"
export * from "./ReportLotArrivals.vue?vue&type=script&lang=js"

import "./ReportLotArrivals.vue?vue&type=style&index=0&id=81803fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81803fc2"]])

export default __exports__